import { createActionConst } from '../../../utils/action.utils';

const SECTION_NAMESPACE = 'SECTION';

export const STORE_SECTION = createActionConst(SECTION_NAMESPACE, 'STORE_SECTION');
export const CLEAR_SECTION = createActionConst(SECTION_NAMESPACE, 'CLEAR_SECTION');
